var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader preloader--hide"},[_c('div',{staticClass:"preloader__img"},[_c('div',{staticClass:"preloader__img-color-wr"},[_c('div',{staticClass:"preloader__img-color"})])])])
}]

export { render, staticRenderFns }